import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useState } from "react";
import store from "../../../../../store";
import { useSelector } from "react-redux";
import {
  setPage,
  setSelectedFilterPopups,
  setSelectedFilterTheme,
  setSelectedPageGroup,
} from "../../../../../features/pageGroupSlice";

export default function PageGroupFilter() {
  const { selectedFilterTheme, selectedFilterPopups, pageGroupData } =
    useSelector((state: any) => state.pageGroup);

  const [searchTheme, setSearchTheme] = useState("");
  const [searchPopup, setSearchPopup] = useState("");

  const filterConfig = [
    {
      key: "theme",
      label: "Select Theme",
      searchTerm: searchTheme,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTheme(e.target.value),
      selectedOption: selectedFilterTheme,
      filterRoot: ["themes"],
      filterName: "name",
      data: pageGroupData,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedFilterTheme(updatedSelection)),
      count: selectedFilterTheme && selectedFilterTheme.length,
      colorSelected:
        selectedFilterTheme !== null && selectedFilterTheme.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "popups",
      label: "Select Popup",
      searchTerm: searchPopup,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchPopup(e.target.value),
      selectedOption: selectedFilterPopups,
      filterRoot: ["popups"],
      filterName: "name",
      data: pageGroupData,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedFilterPopups(updatedSelection)),
      count: selectedFilterPopups && selectedFilterPopups.length,
      colorSelected:
        selectedFilterPopups !== null && selectedFilterPopups.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    // {
    //   key: 'a/b test',
    //   label: 'Select Industry',
    //   selectedOption: selectedAbTest,
    //   filterName: 'ab_test',
    //   data: pageGroups,
    //   onSelectionChange: (updatedSelection: any) => setSelectedAbTest(updatedSelection),
    //   count: selectedAbTest && selectedAbTest.length,
    //   colorSelected: selectedAbTest !== null && selectedAbTest.length > 0 ? '#9C27B0' : '#000000DE',
    //   multiSelect: true,
    //   showSearch: false,
    //   valueMapping: { "null": "NO", "null1": "Inactive" }
    // }
  ];

  //Only used redux implementation for search because url params already implemented for filters

  const clearFilters = () => {
    setSearchPopup("");
    setSearchTheme("");
    store.dispatch(setSelectedFilterPopups([]));
    store.dispatch(setSelectedFilterTheme([]));
    store.dispatch(setSelectedPageGroup(null));
    store.dispatch(setPage(null));
  };

  return (
    <Box data-tracker="31">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
